import React, { useState } from 'react'
import { BaseDrawer } from '@/components/drawer/base-drawer'
import { layerManage } from '@/utils/layer'
import { getBEMCls } from '@/utils/classname'
import SgUpload, { UploadInstance } from '@/components/upload/upload'
import { Image, Progress } from 'antd'

import './upload-material.scss'
import Table, { ColumnsType } from 'antd/lib/table/Table'
import { getQiniuImgUrl, getVideoPreviewUrl } from '@/config/qiniu'
import { Column } from '@/components/layout/layout'
import Button from '@/components/button/button'
import Iconfont from '@/components/iconfont/iconfont'
import NoImg from '@/assets/images/upload-matrail.png'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import $msg from '@/utils/message'

interface UploadMaterialProps {
    onUpload?: () => void
}

const UploadMaterial: React.FC<UploadMaterialProps> = props => {
    const cls = (...arg: string[]) => getBEMCls('upload-material', ...arg)

    const [fileList, setFileList] = useState<UploadInstance[]>([])

    const columns: ColumnsType<UploadInstance> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '素材',
            key: 'fileSrc',
            dataIndex: 'fileSrc',
            render: (value, record) => (
                <div data-margin-top-10 className={cls('ant-img')}>
                    <Image
                        width={50}
                        src={record.filetype === 1 ? getQiniuImgUrl(value) : getVideoPreviewUrl(value)}
                    />
                </div>
            ),
        },
        {
            title: '名称',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '进度',
            key: 'process',
            width: 190,
            render: (val, data) => {
                return data.status === 'error' ? (
                    <div className="danger-color">上传失败</div>
                ) : data.progress === 100 ? (
                    <div className="them-color">上传完成</div>
                ) : (
                    <div style={{ width: 170 }}>
                        <Progress
                            strokeColor={{
                                '0%': '#03d3c4',
                                '100%': '#44e1a6',
                            }}
                            percent={data.progress}
                            size="small"
                        />
                    </div>
                )
            },
        },
        {
            title: '',
            key: 'action',
            render: (val, data, index) => {
                return (
                    <div
                        data-cursor-pointer
                        onClick={() => {
                            fileList.splice(index, 1)
                            setFileList([...fileList])
                        }}
                    >
                        <Iconfont name="icon6yichu-20" size={20} />
                    </div>
                )
            },
        },
    ]

    const uploadImgReq = useRequest(
        (fileListParms: any[]) =>
            $post({
                url: '/material/creatematerial',
                params: {
                    material_list: fileListParms,
                },
            }),
        {
            manual: true,
            onSuccess: () => {
                $msg('success', '上传成功')
                props.onUpload && props.onUpload()
                layerManage.pop()
            },
        },
    )

    const handleUpload = () => {
        const fileListParms = fileList.map(item => ({
            uid: item.uid,
            material_type: item.filetype,
            name: item.name + item.typename,
            url: item.fileSrc,
            size: Math.ceil(item.sizeUnit / 1024),
            duration: item.duration > 0 ? item.duration : undefined,
            proportion: item.proportion ? item.proportion : undefined,
        }))
        uploadImgReq.run(fileListParms)
    }

    return (
        <BaseDrawer
            isShow
            width={640}
            title="上传素材"
            onClose={() => {
                layerManage.pop()
            }}
        >
            <Column data-width-100p data-height-100p>
                <Column data-overflow-auto data-expaned data-align-items-center data-width-100p>
                    <SgUpload
                        multiple
                        onChange={() => {
                            setFileList([...fileList])
                        }}
                        className={cls('btn')}
                        onLoad={data => {
                            fileList.push(data)
                            setFileList([...fileList])
                        }}
                    >
                        <i data-margin-bottom-5 className="upload iconfont icon6shangchuan-24" />
                        上传素材
                    </SgUpload>

                    {fileList.length ? (
                        <div className={cls('table')}>
                            <Table pagination={false} columns={columns} dataSource={fileList} rowKey={r => r.uid} />
                        </div>
                    ) : (
                        <img className={cls('no')} src={NoImg} alt="" />
                    )}

                    <div className={cls('tip')}>
                        <p>注：</p>
                        <p>1.视频大小不超过 100 MB，建议时长在5分钟以内；</p>
                        <p>2.支持的视频文件类型包括：mp4；</p>
                        <p>3.图片大小不能超过10M。</p>
                    </div>
                </Column>
                <div className={cls('footer')}>
                    <Button
                        disabled={!fileList.length}
                        types="default"
                        onClick={handleUpload}
                        loading={uploadImgReq.loading || void 0}
                    >
                        确认上传
                    </Button>
                </div>
            </Column>
        </BaseDrawer>
    )
}

export default UploadMaterial
